import { render, staticRenderFns } from "./Merchant_residence_agreement.vue?vue&type=template&id=571405f7&scoped=true"
import script from "./Merchant_residence_agreement.vue?vue&type=script&lang=js"
export * from "./Merchant_residence_agreement.vue?vue&type=script&lang=js"
import style0 from "./Merchant_residence_agreement.vue?vue&type=style&index=0&id=571405f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571405f7",
  null
  
)

export default component.exports